<template>
  <div class="container">
    <svg width="0" height="0">
      <filter
        id="f"
        x="-50%"
        y="-200%"
        width="200%"
        height="500%"
        primitiveUnits="objectBoundingBox"
      >
        <feGaussianBlur stdDeviation=".025 .2"></feGaussianBlur>
        <feColorMatrix type="saturate" values="1.3"></feColorMatrix>
        <feBlend in="SourceGraphic"></feBlend>
      </filter>
    </svg>
    <h1>LimitYangのblog</h1>
  </div>
</template>

<script>
export default {
  name: 'LightFont'
}
</script>

<style scoped>
/* @import './css/style.css'; */
.container {
  width: 100%;
}
</style>
